export default __webpack_public_path__ + "static/media/section3_bg.2913e76b.png";